import { createSlice } from '@reduxjs/toolkit';

import { UserState } from '../interfaces';

const initialState: UserState = {
    userData: null,
    permissions: [],
    companies: []
};

const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setUser: (state, action) => {
        state.userData = action.payload;
    },
    setUserCompanies: (state, action) => {
        state.companies = action.payload.data.companies;
    },
    setPermissions: (state, action) => {
        state.permissions = action.payload;
    },
    clearUser: (state) => {
        state.userData = null;
        state.permissions = [];
    },
  },
});

export const { setUser, setPermissions, clearUser, setUserCompanies } = userSlice.actions;
export default userSlice.reducer;

export function getUserPermissions(state) {
    return state.user?.permissions;
}

export function getUserCuits(state) {
    return state.user?.companies?.map(company => company.cuit);
}

export function getUserData(state) {
    return state.user;
}

export function getUserCompanies(state) {
    return state.user?.companies;
}